import { render } from "./RedirectCar.vue?vue&type=template&id=6974c340"
import script from "./RedirectCar.vue?vue&type=script&lang=js"
export * from "./RedirectCar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/v3/RedirectCar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6974c340"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6974c340', __exports__)) {
    api.reload('6974c340', __exports__)
  }
  
  module.hot.accept("./RedirectCar.vue?vue&type=template&id=6974c340", () => {
    api.rerender('6974c340', render)
  })

}


export default __exports__